import React, { useEffect } from 'react';
import { useTheme } from '@mui/material';
import { useFeatureFlags } from 'components/context/feature_flags';
import { useTranslation } from 'react-i18next';
import { FOOTNOTE_SYMBOL } from 'components/common/banners/banner_helpers';

const IssuerInstallmentsHeadingPrice = ({ issuerInstallmentsDetails }) => {
  const {
    payment_amount: paymentAmount = '',
    payment_periods_number: paymentPeriodsNumber = 0,
  } = issuerInstallmentsDetails || {};

  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const { issuerInstallmentsEnabled } = useFeatureFlags();

  if (!paymentAmount || !paymentPeriodsNumber || !issuerInstallmentsEnabled) {
    return null;
  }

  useEffect(() => {
    const disclaimerKey = 'productPage.issuerInstallmentsDisclaimer';
    if (Sq.SqShopFooter && i18n.exists(disclaimerKey)) {
      const disclaimer = `${FOOTNOTE_SYMBOL.asteriskSingle} ${t(
        disclaimerKey,
      )}`;

      Sq.SqShopFooter.disclaimers = [
        ...Sq.SqShopFooter.disclaimers,
        disclaimer,
      ];
    }
  }, []);

  return (
    <span
      className="medium-10"
      style={{ marginLeft: theme.spacing(0.5), verticalAlign: 'middle' }}
    >
      <span>
        {t('productPage.issuerInstallmentsPrice', {
          paymentAmount,
          paymentPeriodsNumber,
        })}
      </span>
    </span>
  );
};

export default IssuerInstallmentsHeadingPrice;
